import { IProject } from "Model/Storage/IProject";
import {
  all, call, put, select, spawn, takeEvery
} from "redux-saga/effects";
import { selectSelectedProjectsCount } from "Store/Selectors/UI";
import { hasNoElements } from "Utils/Array";
import { Configuration } from "Utils/Configuration";
import { getMissingFieldList } from "Utils/Project";
import { getProjectsById } from "Workers/Projects";
import { exportProject } from "../../API/Export";
import {
  projectsAdd,
  projectsExportError,
  projectsExportNext,
  projectsExportStart,
  projectsExportSuccess
} from "../Actions";
import { selectExportIndex, selectExportingProject } from "../Selectors/Export";
import { callWithAuth } from "./CallWithAuth";
import { sortAndFilterSaga } from "./Projects";

function* projectsExportStartSaga() {
  try {
    const [exportingProject, config]: [IProject, Configuration] = yield all([
      select(selectExportingProject),
      call(Configuration.getInstanceAsync)
    ]);

    const exportingProjectId = exportingProject[`@id`];
    const isValidForExport = hasNoElements(getMissingFieldList(exportingProject, config));
    if (isValidForExport) {
      yield callWithAuth(exportProject, exportingProjectId);
      const exportedProject: IProject[] = yield callWithAuth(getProjectsById, [exportingProjectId]);
      yield put(projectsAdd(exportedProject));
    }

    const [exportIndex, selectedProjectsCount] = yield all([
      select(selectExportIndex),
      select(selectSelectedProjectsCount),
      spawn(sortAndFilterSaga)
    ]);

    if (exportIndex + 1 < selectedProjectsCount) {
      yield put(projectsExportNext());
      return;
    }

    yield put(projectsExportSuccess(exportingProjectId));
  } catch (e) {
    console.error(e);
    yield put(projectsExportError());
  }
}

export function* ExportSaga() {
  yield takeEvery([projectsExportStart, projectsExportNext], projectsExportStartSaga);
}
